// iScoopCRM logo mark — a scoop lifting it clean, in a rounded blue badge.
// One source of truth: used in the sidebar, login, password-reset, onboarding, exports.
export function ScoopMark({ size = 28, style, className }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true" style={style} className={className}>
      <rect width="40" height="40" rx="11" fill="#0A84FF" />
      <circle cx="20" cy="11.8" r="2.6" fill="#fff" />
      <path d="M11 17.8a9 9 0 0 0 18 0" fill="none" stroke="#fff" strokeWidth="3.3" strokeLinecap="round" />
      <path d="M20 26.8v4.4" stroke="#fff" strokeWidth="3.3" strokeLinecap="round" />
    </svg>
  );
}
